<div class="issue-container">
  <button class="accordion" (click)="togglePanelView()" [ngClass]="{ expanded: panelDisplayed }">
    <div class="issue-type-accordion-title gap-8 full-width">
      <div class="issue-type" *ngIf="!grouped">{{ issue.issue?.title ?? issue.issue.issueTypeDisplayString }}</div>
      <div class="issue-type" *ngIf="grouped">
        {{ resourceTypeString || issue.issue?.title || issue.issue.issueTypeDisplayString }}
      </div>
      <div class="resource-id full-width">
        <div class="template-url" (mouseenter)="showCopyButton = true" (mouseleave)="showCopyButton = false">
          <div class="resource-name" *ngIf="resourceNameString; else noResourceName">
            <span class="resource-type" *ngIf="!grouped && resourceNameString && resourceTypeString"
              >{{ resourceTypeString }}:
            </span>
            <a *ngIf="consoleUrl; else elseBareResourceName" href="{{ consoleUrl }}">{{ resourceNameString }}</a>
            <ng-template #elseBareResourceName>{{ resourceNameString }}</ng-template>
            <a
              class="copy-clipboard"
              *ngIf="resourceNameString && showCopyButton"
              [copy-clipboard]="resourceNameString"
              (click)="togglePanelView()"
            >
              <i class="fa-utility fa-semibold fa-copy"></i>
            </a>
          </div>
          <ng-template #noResourceName>
            <span class="no-resource-text">No associated resource</span>
          </ng-template>
        </div>
      </div>
    </div>
    <div id="expand-glyph">
      <i
        class="fa-utility fa-semibold"
        [ngClass]="{ 'fa-angle-down': !panelDisplayed, 'fa-angle-up': panelDisplayed }"
      ></i>
    </div>
  </button>
  <div class="accordion-panel" [@accordionSlide]="panelDisplayed ? 'expanded' : 'collapsed'" [ngSwitch]="issueType()">
    <certificate-not-found-issue *ngSwitchCase="AcmCertificateNotFoundIssue.displayName" [issue]="issue.issue">
    </certificate-not-found-issue>
    <client-error-issue *ngSwitchCase="ClientErrorIssue.displayName" [issue]="issue.issue"></client-error-issue>
    <refresh-client-error-issue
      *ngSwitchCase="RefreshClientErrorIssue.displayName"
      [issue]="issue.issue"
    ></refresh-client-error-issue>
    <sync-pair-permission-issue
      *ngSwitchCase="SyncPairPermissionIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue.issue"
    >
    </sync-pair-permission-issue>
    <iam-permission-issue
      *ngSwitchCase="SyncPairPermissionIssue.insufficientIamPermissionIssueDisplayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue.issue"
    ></iam-permission-issue>
    <quota-issue *ngSwitchCase="QuotaIssue.displayName" [issue]="issue.issue"></quota-issue>
    <malware-scan-issue *ngSwitchCase="MalwareScanIssue.issueType" [issue]="issue.issue"></malware-scan-issue>
    <marketplace-ami-issue
      *ngSwitchCase="MarketplaceAmiCantBeCopiedIssue.displayName"
      [issue]="issue.issue"
    ></marketplace-ami-issue>
    <multiple-matching-images-issue
      *ngSwitchCase="MultipleMatchingImagesIssue.displayName"
      [issue]="issue.issue"
    ></multiple-matching-images-issue>
    <marketplace-instance-issue
      *ngSwitchCase="MarketplaceInstanceCantBeCopiedIssue.displayName"
      [issue]="issue.issue"
    ></marketplace-instance-issue>
    <marketplace-action-required-issue
      *ngSwitchCase="MarketplaceActionRequiredIssue.displayName"
      [issue]="issue.issue"
    ></marketplace-action-required-issue>
    <ami-storage-not-accessible-issue
      *ngSwitchCase="AmiStorageNotAccessibleIssue.displayName"
      [issue]="issue.issue"
    ></ami-storage-not-accessible-issue>
    <key-pair-not-found-issue
      *ngSwitchCase="KeyPairNotFoundIssue.displayName"
      [issue]="issue.issue"
    ></key-pair-not-found-issue>
    <unconfigured-azure-blob-container-issue
      *ngSwitchCase="UnconfiguredAzureBlobContainerIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue"
    >
    </unconfigured-azure-blob-container-issue>

    <unconfigured-bucket-issue
      *ngSwitchCase="UnconfiguredS3BucketReplicationIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue"
    >
    </unconfigured-bucket-issue>
    <unconfigured-bucket-replication-issue
      *ngSwitchCase="S3BucketReplicationNotConfiguredIssue.displayName"
      [sync-pair]="syncPair"
      [issue]="issue"
    >
    </unconfigured-bucket-replication-issue>
    <bucket-backfill-failed-issue
      *ngSwitchCase="BucketBackfillFailedIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue"
    >
    </bucket-backfill-failed-issue>
    <bucket-name-conflict-issue
      *ngSwitchCase="S3RecoveryBucketNameConflictIssue.displayName"
      [application]="application"
      [issue]="issue"
    ></bucket-name-conflict-issue>
    <drs-agent-not-found-issue
      *ngSwitchCase="DrsAgentNotFoundIssue.displayName"
      [sync-pair]="syncPair"
      [application]="application"
      [issue]="issue"
    >
    </drs-agent-not-found-issue>
    <uninstall-drs-agent-issue
      *ngSwitchCase="UninstallDrsAgentIssue.displayName"
      [sync-pair]="syncPair"
      [application]="application"
      [issue]="issue"
    >
    </uninstall-drs-agent-issue>
    <failback-resource-issue
      *ngSwitchCase="FailbackResourceIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue"
    ></failback-resource-issue>
    <subscription-overage-issue
      *ngSwitchCase="SubscriptionOverageIssue.displayName"
      [issue]="issue"
    ></subscription-overage-issue>
    <detailed-issue
      *ngSwitchCase="DetailedIssue.issueType"
      [issue]="issue.issue"
      [sync-pair]="syncPair"
      [application]="application"
    ></detailed-issue>
    <eks-cluster-permission-issue
      *ngSwitchCase="EksClusterAccessDeniedIssue.displayName"
      [issue]="issue.issue"
    ></eks-cluster-permission-issue>
    <eks-required-endpoint-inaccessible-issue
      *ngSwitchCase="EksRequiredEndpointInaccessibleIssue.displayName"
      [issue]="issue.issue"
    ></eks-required-endpoint-inaccessible-issue>
    <resource-policy-permission-issue
      *ngSwitchCase="ResourcePolicyDeniedIssue.displayName"
      [issue]="issue.issue"
      [viewableIssue]="this.issue"
    ></resource-policy-permission-issue>
    <service-control-policy-permission-issue
      *ngSwitchCase="ServiceControlPolicyDeniedIssue.displayName"
      [issue]="issue.issue"
      [viewableIssue]="this.issue"
    ></service-control-policy-permission-issue>
    <new-target-plan-required-issue
      *ngSwitchCase="NewTargetPlanRequiredIssue.displayName"
      [issue]="issue.issue"
      [application]="application"
    ></new-target-plan-required-issue>
    <persistent-issue
      *ngSwitchCase="PersistentIssue.displayName"
      [application]="application"
      [sync-pair]="syncPair"
      [issue]="issue"
    >
    </persistent-issue>
    <default-issue *ngSwitchDefault [issue]="issue.issue"></default-issue>
    <div class="issue-id-container">Issue ID: {{ issue.issueId }}</div>
  </div>
</div>
